<template>
  <div :aria-label="`Number ${number}`" class="square">
    <div v-if="!isUnit" aria-hidden="true">
      <span class="stringSpan">{{ convertedNumber }}</span>
    </div>
    <div v-else aria-hidden="true">
      <div
        v-for="unit in units"
        :key="`square${unit.value}`"
        track-by="$index"
        :class="['unit', { hidden: unit.hidden }]"
      ></div>
    </div>
  </div>
</template>

<script>
import numberConverter from 'number-to-words';

export default {
  props: {
    number: {
      type: [String, Number],
      required: true
    }
  },

  data() {
    return {
      numbers: [
        {
          path: [],
          name: 'zero'
        },
        {
          path: [4],
          name: 'one'
        },
        {
          path: [0, 8],
          name: 'two'
        },
        {
          path: [0, 4, 8],
          name: 'three'
        },
        {
          path: [0, 2, 6, 8],
          name: 'four'
        },
        {
          path: [0, 2, 4, 6, 8],
          name: 'five'
        },
        {
          path: [0, 2, 3, 5, 6, 8],
          name: 'six'
        },
        {
          path: [0, 2, 3, 4, 5, 6, 8],
          name: 'seven'
        },
        {
          path: [0, 1, 2, 3, 5, 6, 7, 8],
          name: 'eight'
        },
        {
          path: [0, 1, 2, 3, 4, 5, 6, 7, 8],
          name: 'nine'
        }
      ]
    };
  },

  computed: {
    isUnit() {
      return (
        this.number !== '0' && this.numbers.some(number => number.name === this.convertedNumber)
      );
    },

    units() {
      const units = [];
      for (let value = 0; value < 9; value += 1) {
        units.push({
          value,
          hidden:
            this.number === Infinity ||
            !this.numbers[this.number] ||
            !this.numbers[this.number].path.includes(value)
        });
      }
      return units;
    },

    convertedNumber() {
      return numberConverter.toWords(+this.number);
    }
  }
};
</script>

<style lang="scss" scoped>
.square {
  display: inline-block;
  vertical-align: top;
  background-color: #ffc;
  border: 2px solid #000;
  border-radius: 5px;
  width: 192px;
  height: 160px;
  padding: 10px;
  font-weight: 900;
  text-transform: uppercase;
  text-align: center;

  .unit {
    width: 50px;
    height: 30px;
    background-color: #9cf;
    display: inline-block;
    border: 2px solid #000;
    margin-right: 10px;
  }

  span {
    text-transform: uppercase;
    text-align: center;
    display: block;
    padding: 10px;
    font-weight: 900;

    &.stringSpan {
      line-height: 8.5em;
    }
  }

  .hidden {
    visibility: hidden;
  }
}
</style>
